<template>
  <div>
    <v-form>
      <v-layout row="" wrap>
        <v-flex xs12 sm12 md12>
          <v-text-field id="name" hide-details="" :disabled="yolcuadi" v-model="val.YolcuAdi" tabindex="2" :label="$t('Name-of-Passenger')" maxlength="100"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field hide-details="" tabindex="3" v-model="val.RezervasyonVeren" :label="$t('Person-Offering-Booking')"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field hide-details="" tabindex="4" v-model="val.RezervasyonAlan" :label="$t('Person-Receiving-Booking')"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field hide-details="" tabindex="5" v-model="val.Email" :label="$t('Passenger-E-mail')"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field hide-details="" tabindex="6" mask="NNNNNNNNNNNNNNN" v-model="val.BiletTel" :label="$t('Passenger-Phone-Number')"></v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
  export default {
    props: ["value", "yolcuadi"],
    beforeMount: beforeMount,
    components: {

    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      }
    },
    methods: {},
    data() {
     return {}
    
    }
   

  }
  function beforeMount() {


  }
 
 
</script>